import { API_CONFIG } from '@/utils/api';

/** Monta URL pública só com path do ficheiro (fallback se a API não enviar `downloadUrl`). */
export function buildApkUrlFromPath(apkPath: string): string {
    if (!apkPath) return '';
    const t = apkPath.trim();
    if (t.startsWith('http://') || t.startsWith('https://')) return t;
    const baseUrl = API_CONFIG.CDN_URL.endsWith('/') ? API_CONFIG.CDN_URL.slice(0, -1) : API_CONFIG.CDN_URL;
    const name = t.replace(/^\/+/, '');
    if (!name || name.includes('..') || name.includes('/')) return '';
    return `${baseUrl}/app/${encodeURIComponent(name)}`;
}

/**
 * Corpo de `GET /app-version/active` (axios `response.data`).
 * Prefere `downloadUrl` calculado no backend (CDN_PUBLIC_BASE / R2); senão usa `apkPath` + CDN do site.
 */
export function resolveApkDownloadFromActiveResponse(body: unknown): string | null {
    if (body == null || typeof body !== 'object') return null;
    const root = body as Record<string, unknown>;
    const innerRaw = root.data;
    const inner =
        innerRaw != null && typeof innerRaw === 'object' && !Array.isArray(innerRaw)
            ? (innerRaw as Record<string, unknown>)
            : root;

    const downloadUrl = inner.downloadUrl;
    if (typeof downloadUrl === 'string') {
        const u = downloadUrl.trim();
        if (u.startsWith('http://') || u.startsWith('https://')) return u;
    }

    const apkPath = inner.apkPath;
    if (typeof apkPath === 'string' && apkPath.trim()) {
        const built = buildApkUrlFromPath(apkPath.trim());
        return built || null;
    }
    return null;
}
